<template>
  <div class="row">
    <div class="col-md-12">
 
     holi
   
    </div>
  </div>
</template>
<script>
  import {NumberFormat} from "../../helpers/NumberFormat"
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name:'QuoteCurrency',
    components:{FontAwesomeIcon},
    props:['currencies'],
    data() {
      return {
        loading:false,
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'code', label: 'Code' },
          { key: 'exchange', label: 'Tipo de Cambio' },  
          { key: 'name', label:'Divisa'}
        ]
      }
    },
    methods:{
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 2, ',', '.')
      },
      getZoneName(zone){
        if (zone == 'foreign') {
          return 'Foraneo'
        }
        return 'Local'
      }
    }
  }
</script>